<template lang="pug">
.d-flex.align-center.justify-center
  .d-flex.flex-column.align-center
    v-btn(icon @click="hour--" :disabled="hour === 1")
      v-icon $yzi-chevron-up
    v-menu(max-height=240)
      template(v-slot:activator='{ on }')
        v-btn.round-xl.border-input.text-sm.font-normal(v-on="on" text) {{ hour | twoDigitTime }}
      v-list(dense)
        v-list-item(v-for="h in 12" :key="h" @click="hour = h")
          v-list-item-title {{ h | twoDigitTime }}
    v-btn(icon @click="hour++" :disabled="hour === 12")
      v-icon $yzi-chevron-down
  .px-1 :
  .d-flex.flex-column.align-center
    v-btn(icon @click="minute--" :disabled="minute === 0")
      v-icon $yzi-chevron-up
    v-menu(max-height=240)
      template(v-slot:activator='{ on }')
        v-btn.round-xl.border-input.text-sm.font-normal(v-on="on" text) {{ minute | twoDigitTime }}
      v-list(dense)
        v-list-item(v-for="m in 60" :key="m" @click="minute = m - 1")
          v-list-item-title {{ m - 1 | twoDigitTime }}
    v-btn(icon @click="minute++" :disabled="minute === 59")
      v-icon $yzi-chevron-down
  .ml-4
    v-item-group(mandatory @change="onChanged" flat)
      div(v-for="option in timeOptions" :key="option")
        v-item(v-slot="{ active, toggle }")
          .round-lg.py-2.px-4.mb-1.cursor-pointer(
            :style="active ? activeStyle : inactiveStyle" 
            @click="toggle"
            flat
            rounded="lg"
          )
            .text-xs.uppercase.text-center.font-medium {{ option }}
</template>

<script>
export default {
  name: 'YTimePicker',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data: () => ({
    hour: 12,
    minute: 0,
    ampm: 'pm',
    activeStyle: {
      background: '#333',
      color: 'white'
    },
    inactiveStyle: {
      backgroundColor: '#EEE'
    },
    timeOptions: ['am', 'pm']
  }),
  computed: {
    dataValue() {
      const convertTwoDigit = this.$options.filters.twoDigitTime
      let hours = this.hour
      if (this.ampm === 'pm' && hours < 12) {
        hours += 12
      }
      if (this.ampm === 'am' && hours === 12) {
        hours = 0
      }
      return `${convertTwoDigit(hours)}:${convertTwoDigit(this.minute)}:00`
    }
  },
  watch: {
    dataValue: {
      immediate: true,
      handler (val) {
        if (val) {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    onChanged(value) {
      this.ampm = this.timeOptions[value]
    }
  }
}
</script>
